function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import mapObjIndexed from 'ramda/src/mapObjIndexed';
import styled, { css, ThemeProvider } from '../styled-components';
import { breakpointGetter, mapMedia } from '../media';

var themeForBreakpoint = function themeForBreakpoint(props, parentTheme) {
  return function (breakpointValue, breakpointName) {
    var prop = breakpointGetter(breakpointName, props);
    var gap = prop('gap');
    var columnMargin = prop('columnMargin');

    if (typeof gap === 'undefined' && breakpointName === 'all') {
      gap = parentTheme.rowGap;
    }

    return {
      columnMargin: typeof columnMargin !== 'undefined' ? columnMargin : undefined,
      halfGap: typeof gap !== 'undefined' ? gap / 2 : undefined
    };
  };
};

export var Row = function Row(props) {
  var addGridToTheme = function addGridToTheme(parentTheme) {
    var grid = mapObjIndexed(themeForBreakpoint(props, parentTheme), parentTheme.breakpoints);
    return _objectSpread({}, parentTheme, {
      grid: grid
    });
  };

  return React.createElement(ThemeProvider, {
    theme: addGridToTheme
  }, React.createElement(RowImpl, props));
};

var row = function row() {
  return css(["display:flex;flex:0 1 auto;flex-direction:row;flex-wrap:wrap;box-sizing:border-box;", ";"], mapMedia(function (prop, grid) {
    var halfGap = grid('halfGap');
    var margin = prop('margin');
    return [typeof margin === 'number' && {
      marginBottom: "".concat(margin, "px")
    }, typeof halfGap === 'number' && {
      marginLeft: "-".concat(halfGap, "px")
    }, typeof halfGap === 'number' && {
      marginRight: "-".concat(halfGap, "px")
    }];
  }));
};

var RowImpl =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Grid__RowImpl",
  componentId: "sc-1fnkyyt-0"
})(["", ";"], row);
var COLUMN_WIDTHS = ['8.333333333', '16.666666667', '25', '33.333333333', '41.666666667', '50', '58.333333333', '66.666666667', '75', '83.333333333', '91.666666667', '100'];

var sizing = function sizing(span) {
  if (typeof span === 'undefined') {
    return null;
  }

  if (span === 'auto') {
    return {
      flexBasis: '0',
      flexGrow: '1',
      maxWidth: '100%'
    };
  }

  return {
    flexBasis: "".concat(COLUMN_WIDTHS[span - 1], "%"),
    maxWidth: "".concat(COLUMN_WIDTHS[span - 1], "%")
  };
};

var column = function column() {
  return css(["flex:0 0 auto;box-sizing:border-box;", ";"], mapMedia(function (prop, grid) {
    var halfGap = grid('halfGap');
    var columnMargin = grid('columnMargin');
    var span = prop('span');
    var shift = prop('shift');
    var order = prop('order');
    var orderPosition = order === 'first' ? -1 : order === 'last' ? 99 : order;
    var margin = prop('margin');
    var realMargin = typeof margin === 'number' ? margin : typeof columnMargin === 'number' ? columnMargin : undefined;
    return [typeof realMargin === 'number' && {
      marginBottom: "".concat(realMargin, "px")
    }, typeof halfGap === 'number' && {
      paddingLeft: "".concat(halfGap, "px"),
      paddingRight: "".concat(halfGap, "px")
    }, sizing(span), shift && {
      marginLeft: "".concat(COLUMN_WIDTHS[shift - 1], "%")
    }, orderPosition && {
      order: orderPosition
    }];
  }));
};

var ColumnImpl =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Grid__ColumnImpl",
  componentId: "sc-1fnkyyt-1"
})(["", ";"], column);
export var Column = function Column(props) {
  return React.createElement(ColumnImpl, props);
};
Column.defaultProps = {
  span: 'auto'
};